import React from "react";

/* Page header — title, optional eyebrow + subtitle, breadcrumb, right actions. */
export function PageHeader({ title, eyebrow, subtitle, breadcrumb, actions, style, ...rest }) {
  return (
    <header
      style={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        gap: 24,
        flexWrap: "wrap",
        ...style,
      }}
      {...rest}
    >
      <div style={{ minWidth: 0 }}>
        {breadcrumb ? (
          <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, fontWeight: 500, color: "var(--text-muted)", marginBottom: 8 }}>
            {breadcrumb}
          </div>
        ) : null}
        {eyebrow ? (
          <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: "0.06em", textTransform: "uppercase", color: "var(--green-success)", marginBottom: 6 }}>
            {eyebrow}
          </div>
        ) : null}
        <h1 style={{ fontFamily: "var(--font-sans)", fontWeight: 700, fontSize: "var(--fs-h1)", letterSpacing: "-0.02em", color: "var(--text-strong)", lineHeight: 1.05 }}>
          {title}
        </h1>
        {subtitle ? (
          <p style={{ fontFamily: "var(--font-sans)", fontWeight: 500, fontSize: 14, color: "var(--text-muted)", marginTop: 8, maxWidth: 560 }}>
            {subtitle}
          </p>
        ) : null}
      </div>
      {actions ? <div style={{ display: "flex", alignItems: "center", gap: 10, flex: "none" }}>{actions}</div> : null}
    </header>
  );
}

export default PageHeader;
